/** Match services/recoveryStatusService.js */
const RECOVERED_MULTIPLIER_FROM_BOTTOM = 10;
const RECOVERING_MIN_PERCENT_FROM_BOTTOM = 10;
const ATH_RECOVERED_TOLERANCE = 0.995;

export function getRecoveryStatus(recovery) {
  const bottom = Number(recovery.bottomMarketCap) || 0;
  const current = Number(recovery.currentMarketCap) || 0;
  const ath = Number(recovery.allTimeHigh) || 0;
  const fromBottom = recovery.recoveryPercentage ?? (
    bottom > 0 ? ((current - bottom) / bottom) * 100 : 0
  );

  if (bottom > 0 && current >= bottom * RECOVERED_MULTIPLIER_FROM_BOTTOM) {
    return 'recovered';
  }
  if (ath > 0 && current >= ath * ATH_RECOVERED_TOLERANCE) {
    return 'recovered';
  }
  if (fromBottom >= RECOVERING_MIN_PERCENT_FROM_BOTTOM || recovery.isRecovering) {
    return 'recovering';
  }
  return 'drawdown';
}

export const RECOVERY_TABS = [
  { id: 'recovering', name: 'Recovery', icon: '📈', description: 'Up 10%+ from bottom, below 10x and not at ATH yet' },
  { id: 'drawdown', name: 'Drawdown', icon: '📉', description: 'Still near bottom, under 10% bounce from low' },
  { id: 'recovered', name: 'Recovered', icon: '✅', description: '10x+ from tracked bottom or at/new ATH' },
];
